<template>
  <component
    v-if="editProfileCondition"
    v-model="modalVisibility"
    :is="mobileMenu ? 'v-dialog' : 'div'"
    :class="{ 'fill-width ': !mobileMenu }"
    scrollable
    overlay-color="black"
    overlay-opacity=".7"
    @click:outside="closeModal"
    @keydown.esc="closeModal"
  >
    <v-card
      color="transparent"
      class="modal-border background-darkest-blur mb-1"
      :class="{ 'scrollable-desktop-container': !mobileMenu }"
    >
      <v-card-title class="d-flex justify-center py-2 px-0">
        <v-row justify="start">
          <v-col cols="2" align-self="center" class="d-flex justify-start">
            <v-btn icon @click="closeModal">
              <v-icon class="success--text font-weight-bolder"
                >mdi-close</v-icon
              >
            </v-btn>
          </v-col>
          <v-col
            cols="8"
            align-self="center"
            class="d-flex justify-center border-bottom-success-1px"
          >
            <span class="secondary--text"> {{ $translate("profile") }} </span>
          </v-col>
        </v-row>
      </v-card-title>
      <v-card elevation="0" color="transparent" :loading="apiRequestPending">
        <template slot="progress">
          <v-progress-linear
            color="success"
            indeterminate
            height="2"
            class="position-absolute"
          ></v-progress-linear>
        </template>
        <v-card-text class="pa-0 mx-3 width-unset rounded">
          <v-row justify="center" class="mt-2">
            <v-col
              cols="3"
              align-self="center"
              class="pa-0 d-flex justify-center"
            >
              <transition
                name="animate__zoomIn"
                enter-active-class="animate__animated animate__zoomIn animate__delay-1s"
                leave-active-class="animate__animated animate__zoomOut"
                appear
              >
                <v-img
                  class="rounded-circle"
                  :src="
                    user.avatar
                      ? require('@/assets/avatars/' + user.avatar)
                      : null
                  "
                  alt="avatar"
                ></v-img>
              </transition>
            </v-col>
          </v-row>
          <v-form
            fluid
            class="mt-3 pa-3 scrollable-form"
            ref="form"
            v-model="valid"
          >
            <transition
              name="animate__fadeIn"
              enter-active-class="animate__animated animate__fadeIn animate__delay-1s-list"
              leave-active-class="animate__animated animate__fadeOut"
              appear
            >
              <v-row justify="center" class="mb-4">
                <v-col
                  cols="4"
                  align-self="center"
                  class="d-flex justify-center"
                >
                  <TwoLayerButton
                    :outer-container-class="'outer-button-layer'"
                    :inner-container-class="'inner-button-layer pa-2 font-size-xs'"
                    :button-text="$translate('changeAvatar')"
                    :primary-color="'blue'"
                    @button-clicked="changeAvatarVisibility = true"
                  />
                </v-col>
              </v-row>
            </transition>
            <transition
              name="animate__fadeIn"
              enter-active-class="animate__animated animate__fadeIn animate__delay-2s-list"
              leave-active-class="animate__animated animate__fadeOut"
              appear
            >
              <v-row class="mb-2" no-gutters>
                <v-col cols="12" class="mb-1">
                  <span
                    class="font-weight-bold vListActionTextColor--text text-caption"
                  >
                    {{ $translate("nickName") }}:
                  </span>
                </v-col>
                <v-col cols="12" autocomplete="off" align-self="center">
                  <v-text-field
                    rounded
                    outlined
                    hide-details
                    dense
                    dark
                    color="success"
                    type="text"
                    v-model="user.nickname"
                    class="modal-inputs-background"
                  />
                </v-col>
              </v-row>
            </transition>
            <transition
              name="animate__fadeIn"
              enter-active-class="animate__animated animate__fadeIn animate__delay-3s-list"
              leave-active-class="animate__animated animate__fadeOut"
              appear
            >
              <v-row class="mb-2" no-gutters>
                <v-col cols="12" class="mb-1">
                  <span
                    class="font-weight-bold vListActionTextColor--text text-caption"
                  >
                    {{ $translate("email") }}:</span
                  >
                </v-col>
                <v-col cols="12" align-self="center">
                  <v-text-field
                    rounded
                    outlined
                    hide-details
                    dense
                    dark
                    name="email"
                    color="success"
                    type="text"
                    v-model="user.email"
                    class="modal-inputs-background"
                    autocomplete="off"
                    :rules="[rules.emailValidation]"
                    :readonly="user.emailStatus"
                  >
                    <template v-slot:append>
                      <v-icon v-if="user.emailStatus" class="success--text"
                        >mdi-checkbox-marked-circle
                      </v-icon>
                      <v-icon
                        v-else
                        class="red--text cursor-pointer"
                        @click="openEditProfileVerification('email')"
                        >mdi-alert-circle
                      </v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </transition>
            <transition
              name="animate__fadeIn"
              enter-active-class="animate__animated animate__fadeIn animate__delay-4s-list"
              leave-active-class="animate__animated animate__fadeOut"
              appear
            >
              <v-row class="mb-2" no-gutters>
                <v-col cols="12" class="mb-1">
                  <span
                    class="font-weight-bold vListActionTextColor--text text-caption"
                  >
                    {{ $translate("phoneNumber") }}:</span
                  >
                </v-col>
                <v-col cols="12" align-self="center">
                  <v-text-field
                    rounded
                    outlined
                    hide-details
                    dense
                    dark
                    color="success"
                    class="modal-inputs-background"
                    name="phoneNumber"
                    v-mask="'##############'"
                    type="text"
                    :readonly="user.phoneStatus"
                    v-model="user.phoneNumber"
                    autocomplete="off"
                  >
                    <!-- :rules="[rules.phoneNumberValidation]" -->
                    <template v-slot:append>
                      <v-icon v-if="user.phoneStatus" class="success--text"
                        >mdi-checkbox-marked-circle
                      </v-icon>
                      <v-icon
                        v-else
                        class="red--text cursor-pointer"
                        @click="openEditProfileVerification('phoneNumber')"
                        >mdi-alert-circle
                      </v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </transition>
            <transition
              name="animate__fadeIn"
              enter-active-class="animate__animated animate__fadeIn animate__delay-5s-list"
              leave-active-class="animate__animated animate__fadeOut"
              appear
            >
              <v-row class="mb-2" no-gutters>
                <v-col cols="12" class="mb-1">
                  <span
                    class="font-weight-bold vListActionTextColor--text text-caption"
                    >{{ $translate("currentPassword") }}:</span
                  >
                </v-col>
                <v-col cols="12" align-self="center">
                  <v-text-field
                    rounded
                    outlined
                    hide-details
                    dense
                    dark
                    color="success"
                    class="primary-autofill modal-inputs-background"
                    autocomplete="off"
                    name="currentPassword"
                    type="password"
                    :rules="[currentPasswordRequired]"
                    v-model="currentPassword"
                  />
                </v-col>
              </v-row>
            </transition>
            <transition
              name="animate__fadeIn"
              enter-active-class="animate__animated animate__fadeIn animate__delay-5s-list"
              leave-active-class="animate__animated animate__fadeOut"
              appear
            >
              <v-row class="mb-2" no-gutters>
                <v-col cols="12" class="mb-1">
                  <span
                    class="font-weight-bold vListActionTextColor--text text-caption"
                    >{{ $translate("newPassword") }}:</span
                  >
                </v-col>
                <v-col cols="12" align-self="center">
                  <v-text-field
                    rounded
                    outlined
                    hide-details
                    dense
                    dark
                    color="success"
                    class="modal-inputs-background"
                    autocomplete="new-password"
                    :rules="[
                      rules.strongPassword,
                      rules.minLength,
                      newPasswordRequired,
                    ]"
                    type="password"
                    v-model="newPassword"
                  >
                    <template v-if="passwordIsStrong !== ''" v-slot:append>
                      <v-icon
                        :class="
                          passwordIsStrong ? 'success--text' : 'red--text'
                        "
                      >
                        {{
                          passwordIsStrong
                            ? "mdi-checkbox-marked-circle"
                            : "mdi-alert-circle"
                        }}
                      </v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </transition>
            <transition
              name="animate__fadeIn"
              enter-active-class="animate__animated animate__fadeIn animate__delay-5s-list"
              leave-active-class="animate__animated animate__fadeOut"
              appear
            >
              <v-row class="mb-2" no-gutters>
                <v-col cols="12" class="mb-1">
                  <span
                    class="font-weight-bold vListActionTextColor--text text-caption"
                  >
                    {{ $translate("reEnterPassword") }}:
                  </span>
                </v-col>
                <v-col cols="12" align-self="center">
                  <v-text-field
                    rounded
                    outlined
                    hide-details
                    dense
                    dark
                    color="success"
                    class="modal-inputs-background"
                    type="password"
                    autocomplete="off"
                    :rules="[matchingPasswords]"
                    v-model="reEnterPassword"
                  >
                    <template v-if="doesNewPasswordsMatch !== ''" v-slot:append>
                      <v-icon
                        :class="
                          doesNewPasswordsMatch ? 'success--text' : 'red--text'
                        "
                      >
                        {{
                          doesNewPasswordsMatch
                            ? "mdi-checkbox-marked-circle"
                            : "mdi-alert-circle"
                        }}
                      </v-icon>
                    </template>
                  </v-text-field>
                </v-col>
              </v-row>
            </transition>
          </v-form>
        </v-card-text>
      </v-card>
      <v-card-actions class="transparent mb-2">
        <v-row no-gutters justify="center">
          <v-col cols="6" class="mb-2">
            <TwoLayerButton
              :outer-container-class="'outer-button-layer'"
              :inner-container-class="'inner-button-layer py-2 px-0 font-size-xs'"
              :button-text="$translate('apply')"
              :primary-color="'primary'"
              :disable-button="!valid"
              :disable-theme-active="!valid"
              :loading="apiRequestPending"
              @button-clicked="changeUserInfo"
            />
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
    <ChangeAvatar
      :openedFrom="'editProfile'"
      :imageSource="'avatars'"
      :defaultAvatarSelected="{
        name: user.avatar,
        address: user.avatar
          ? require(`@/assets/avatars/${user.avatar}`)
          : null,
      }"
      :visibility="changeAvatarVisibility"
      @avatarChangedEvent="setNewUserAvatar"
      @closeModal="onChangeAvatarModalClose"
    />
    <EditProfileVerification
      :visibility="changeEditProfileVerificationVisibility"
      @toggleVisibility="
        changeEditProfileVerificationVisibility =
          !changeEditProfileVerificationVisibility
      "
      :editProfileFieldVerification="editProfileVerificationPage"
    />
  </component>
  <v-container fluid v-else-if="desktopLoadingPageCondition">
    <v-row justify="center">
      <v-col cols="8" align-self="center" class="d-flex justify-center">
        <v-progress-circular
          indeterminate
          color="success"
        ></v-progress-circular>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import Services from "@/services/user-services.js";
import toastServices from "@/services/toast";
import ChangeAvatar from "@/components/Modals/ChangeAvatar";
import { mapGetters, mapMutations } from "vuex";
import EditProfileVerification from "@/components/Modals/EditProfile/EditProfileVerification";
import TwoLayerButton from "@/components/Helper/TwoLayerButton";
import { Mixin } from "@/store/globalMixins";

export default {
  name: "EditProfile",
  mixins: [Mixin],
  props: { visibility: Boolean },
  components: { TwoLayerButton, EditProfileVerification, ChangeAvatar },
  data: () => {
    return {
      modalVisibility: false,
      user: {
        nickname: "",
        username: "",
        id: "",
        email: "",
        phoneNumber: "",
        phoneStatus: false,
        emailStatus: false,
      },
      valid: true,
      changeAvatarVisibility: false,
      changeEditProfileVerificationVisibility: false,
      editProfileVerificationPage: "",
      apiRequestPending: false,
      userInfoApiRequestPending: false,
      currentPassword: "",
      newPassword: "",
      reEnterPassword: "",
      avatarTransition: false,
      doesNewPasswordsMatch: "",
      passwordIsStrong: "",
      selectedAvatar: "",
      userInfoChangedByUser: false,
      rules: {
        required: (v) => !!v || "Required.",
        emailValidation: (v) =>
          !!v && /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/i.test(v)
            ? true
            : !v
            ? true
            : "Email is not valid!",
        minLength: (v) => v.length >= 5 || v.length === 0 || "Min 5 characters",
        strongPassword: (v) =>
          !!v && /^[a-zA-Z0-9!@#\$%\^\&*\)\(+=._-]+$/g.test(v)
            ? true
            : !v
            ? true
            : " Password must contain no bad characters (E.g `{} : / \ are considered bad characters)!",
        phoneNumberValidation: (v) =>
          (v.length === 14 && v.substr(0, 2) === "00") ||
          v.length === 0 ||
          "Phone number must start with '00' and country code",
      },
    };
  },
  computed: {
    ...mapGetters(["getUserInfo", "mobileMenu"]),
    editProfileCondition() {
      return (
        this.visibility &&
        (this.mobileMenu ||
          (!this.mobileMenu && !this.userInfoApiRequestPending))
      );
    },

    desktopLoadingPageCondition() {
      return (
        !this.mobileMenu && this.visibility && this.userInfoApiRequestPending
      );
    },
  },
  methods: {
    ...mapMutations(["setUserInfo"]),
    matchingPasswords() {
      return (
        this.reEnterPassword === this.newPassword || "Password does not match"
      );
    },
    currentPasswordRequired() {
      return this.newPassword && !this.currentPassword
        ? "Enter Your Old Password!"
        : true;
    },
    newPasswordRequired() {
      return this.currentPassword && !this.newPassword
        ? "Enter a new password!"
        : true;
    },
    closeModal() {
      this.$emit("closeModal");
      this.clearAllData();
    },
    clearPassword() {
      this.currentPassword = "";
      this.newPassword = "";
      this.reEnterPassword = "";
    },
    clearSelectedAvatar() {
      this.selectedAvatar = {};
    },
    clearUserData() {
      this.user = {
        nickname: "",
        username: "",
        id: "",
        email: "",
        phoneNumber: "",
        phoneStatus: false,
        emailStatus: false,
      };
    },
    clearAllData() {
      this.clearPassword();
      this.clearSelectedAvatar();
    },
    onChangeAvatarModalClose(hasAvatarUpdated) {
      if (hasAvatarUpdated) this.user.avatar = null;
      this.changeAvatarVisibility = false;
    },
    setNewUserAvatar(avatar) {
      this.selectedAvatar = avatar;
      this.user.avatar = avatar.name;
    },
    openEditProfileVerification(page) {
      if (
        this.getUserInfo.email !== this.user.email ||
        this.getUserInfo.phoneNumber !== this.user.phoneNumber
      ) {
        toastServices.typeError("Please apply changes before verify!");
        return;
      }
      this.editProfileVerificationPage = page;
      this.changeEditProfileVerificationVisibility = true;
    },
    // changeAvatar() {
    //   this.apiRequestPending = true;
    //   Services.patch("accounts/change-avatar", {
    //     avatar: this.selectedAvatar.name,
    //   }).then(
    //     () => {
    //       this.selectedAvatar = {};
    //       toastServices.typeSuccess("Avatar is Changed!");
    //       this.apiRequestPending = false;
    //       this.closeModal(true);
    //     },
    //     (error) => {
    //       this.apiRequestPending = false;
    //       Services.apiError(error.body.message, error.status);
    //     }
    //   );
    // },
    changeUserInfo() {
      if (!Mixin.methods.isInputValidChecker(this.user.nickname)) {
        Mixin.methods.validInputErrorMsg("Nickname");
        return;
      }
      this.apiRequestPending = true;

      const dataToServer = {
        nickname: this.user.nickname,
        avatar: this.selectedAvatar.name ? this.selectedAvatar.name : null,
        email: !this.user.emailStatus ? this.user.email : null,
        phoneNumber: !this.user.phoneStatus ? this.user.phoneNumber : null,
        newPassword: this.reEnterPassword || null,
        prePassword: this.currentPassword || null,
      };
      Services.patch("accounts/update-account", dataToServer).then(
        (res) => {
          this.clearSelectedAvatar();
          toastServices.typeSuccess("Info updated");
          this.setUserdata(res.body);
          this.apiRequestPending = false;
          this.closeModal();
          this.clearUserData();
        },
        (error) => {
          Services.apiError(error.body.message, error.status);
          this.apiRequestPending = false;
        }
      );
    },
    getUserInfoApi() {
      this.userInfoApiRequestPending = true;
      Services.get(`accounts/user-info/`).then(
        (res) => {
          this.user = res.body;
          this.setUserdata(res.body);
          this.userInfoApiRequestPending = false;
        },
        (error) => {
          console.log("error occurred getting user info...");
          this.userInfoApiRequestPending = false;
          Services.apiError(error.body.message, error.status);
        }
      );
    },
    setUserdata(data) {
      const resBody = data;
      const userData = {
        userId: resBody.id,
        code: resBody.code,
        username: resBody.username,
        avatar: resBody.avatar,
        email: resBody.email,
        phoneNumber: resBody.phoneNumber,
        nickname: resBody.nickname,
        roles: resBody.roles,
      };
      this.user = {
        ...userData,
        rank: resBody.rank ? resBody.rank : 0,
        phoneStatus: resBody.phoneStatus === "VERIFIED",
        emailStatus: resBody.emailStatus === "VERIFIED",
      };
      this.setUserInfo(userData);
    },
  },
  watch: {
    visibility(value) {
      if (value) this.getUserInfoApi();
      this.modalVisibility = value;
    },
    modalVisibility(value) {
      if (!value) this.closeModal();
    },
    // user: {
    //   deep: true,
    //   handler(newVal, oldVal) {
    //     this.userInfoChangedByUser =
    //       JSON.stringify(newVal) !== JSON.stringify(oldVal);
    //     console.log(this.userInfoChangedByUser);
    //   },
    // },
  },
  created() {
    //because in desktop, for the first time the modal will be created instead of opened.
    if (!this.mobileMenu) this.getUserInfoApi();
  },
};
</script>
<style scoped>
.primary-autofill >>> input:-webkit-autofill,
.primary-autofill >>> input:-webkit-autofill:hover,
.primary-autofill >>> input:-webkit-autofill:focus,
.primary-autofill >>> input:-webkit-autofill:active {
  -webkit-box-shadow: 0 0 0 30px transparent inset !important;
}

.primary-autofill >>> input:-webkit-autofill {
  -webkit-text-fill-color: white !important;
  border-radius: 0;
}
.scrollable-desktop-container {
  min-height: 55vh;
  max-height: 65vh;
  overflow-y: hidden;
  overflow-x: hidden;
}
.scrollable-form {
  min-height: 45vh;
  max-height: 50vh;
  overflow-y: auto;
}

@media only screen and (max-height: 1400px) and (min-width: 990px) {
  .scrollable-form {
    min-height: 38vh;
    max-height: 41vh;
  }
}
@media only screen and (max-height: 900px) and (min-width: 990px) {
  .scrollable-form {
    min-height: 35vh;
    max-height: 38vh;
  }
}
@media only screen and (max-height: 750px) and (min-width: 990px) {
  .scrollable-form {
    min-height: 33vh;
    max-height: 35vh;
  }
}
@media only screen and (max-height: 650px) and (min-width: 990px) {
  .scrollable-form {
    min-height: 30vh;
    max-height: 31vh;
  }
}
.width-unset {
  width: unset !important;
}
</style>
